















import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import { SectionCore } from '@/mixins/sectionCore'
import SectionBasic from '@/components/SectionBasic.vue'
import BlockText from '@/components/BlockText.vue'
import BlockBreadCrumbs from '@/components/BlockBreadCrumbs.vue'

@Component
class SectionText extends mixins(SectionCore) {
  @Prop() readonly fullwidth: boolean = false
  @Prop() readonly showFullTable: 'Да' | 'Нет' | '' = ''
  static options: any
}

export default defineComponent({
  name: 'SectionText',
  components: {
    BlockBreadCrumbs,
    SectionBasic,
    BlockText,
  },
  props: SectionText.options.props,

  setup() {},
})
